import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appMaxLength]',
  standalone: true,
})
export class MaxLengthDirective {
  @Input() appMaxLength: number = 0;

  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event']) onInputEvent(event: any) {
    if (this.appMaxLength > 0) {
      this.el.nativeElement.value = this.el.nativeElement.value.substring(
        0,
        this.appMaxLength
      );
    }
  }

  @HostListener('paste', ['$event']) onPasteEvent(event: ClipboardEvent) {
    if (this.appMaxLength > 0) {
      event.preventDefault();
      const pastedText = (
        event.clipboardData || (window as any).clipboardData
      ).getData('text');
      this.el.nativeElement.value = pastedText.substring(0, this.appMaxLength);
      const newevent = new Event('input', { bubbles: true });
      this.el.nativeElement.dispatchEvent(newevent);
    }
  }

  @HostListener('drop', ['$event']) onDropEvent(event: DragEvent) {
    if (this.appMaxLength > 0) {
      event.preventDefault();
      const droppedText = event.dataTransfer?.getData('text');
      this.el.nativeElement.value = droppedText?.substring(
        0,
        this.appMaxLength
      );
      const newevent = new Event('input', { bubbles: true });
      this.el.nativeElement.dispatchEvent(newevent);
    }
  }
}
